<template>
  <div class="news_list offers_list   wc-lg">
    <OffersListHeader
      :content="content"
      :unic_id="_.get(this.contentData, 'conf.unicId')"
    />
    <div class="offers_list__inner news_list__inner container bg_white">
      <div class="offers_list__inner--grid news_list__inner--grid grid">
        <router-link
          :to="$store.getters['main/getSingleUrl'](story)"
          :key="index"
          v-for="(story, index) in $store.state.main.offers_content"
          class="offers_list__box news_list__box  flex column"
        >
          <div class="offers_list__img_wrapper news_list__img_wrapper br-12">
            <div
              class="offers_list__label flex j_center"
              v-if="_.get(story, 'company_image[0].url')"
            >
              <img :src="_.get(story, 'company_image[0].url')" />
            </div>
            <div class="offers_list__img_overlay bg-overlay"></div>
            <h4 class="f-55 bold f-white">{{ story.offer }}</h4>
            <img
              :src="story.cover_image[0].url"
              class="cover"
              :alt="
                $route.name == 'PageViewRouter_ge' && story.seo_keywords_ge
                  ? story.seo_keywords_ge
                  : $route.name == 'PageViewRouter_en' && story.seo_keywords_en
                  ? story.seo_keywords_en
                  : ''
              "
            />
          </div>

          <div class="offers_list__text-box news_list__text-box flex column">
            <h2 class="f-18 bold uppercase">{{ story.title }}</h2>
            <h3 class="f-14 medium">{{ story.teaser }}</h3>
            <div class="f-16 bold uppercase f-light-purple flex a_center">
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                  fill="#7063e9"
                />
              </svg>

              {{ $fn.tr("Get Offer") }}
            </div>
          </div>
        </router-link>
      </div>
      <div
        class="news_list__load_more flex j_center a_center"
        v-if="offers_content.length < $store.state.main.offers_listCount"
      >
        <div
          class="news_list__load_more--btn button pointer bg-light-purple wc-lg"
          @click="load_more($store.state.main.offers_search_keywords)"
        >
          <span class="f-14 bold uppercase f-white">{{
            $fn.tr("მეტის ჩვენება")
          }}</span>
        </div>
      </div>

      <div
        class="search__results_wrapper flex j_center wc-lg"
        v-if="offers_content.length == 0"
      >
        <span class="f-55 bold">{{ $fn.tr("შედეგი არ მოიძებნა") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import OffersListHeader from "@/components/modules/OffersListHeader";
import moment from "@/helpers/moment";
import fn from "@/helpers/func";

export default {
  props: ["contentData"],
  mixins: [resize_handler],
  components: {
    OffersListHeader
  },
  data() {
    return {
      date_picked: "",
      active_calendar: false,
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      }
    };
  },
  computed: {
    page_count() {
      this.$store.state.main.offers_page_count = _.get(
        this.contentData,
        "conf.page_count"
      );
      return _.get(this.contentData, "conf.page_count");
    },
    uniq_id() {
      return _.get(this.contentData, "conf.unicId");
    },
    content_store() {},
    format_calendar() {
      if (this.date_picked) {
        this.date_picked = {
          end: moment(this.date_picked.end).format("YYYY-MM-DD"),
          start: moment(this.date_picked.start).format("YYYY-MM-DD")
        };
        return this.date_picked;
      } else {
        return (this.date_picked = "");
      }
    },
    offers_content() {
      return this.$store.state.main.offers_content;
    },
    content() {
      return _.get(this.contentData, "data.list");
    }
  },
  created() {
    this.$store.state.main.offers_content = _.get(
      this.contentData,
      "data.list"
    );
    this.$store.state.main.offers_listCount = _.get(
      this.contentData,
      "data.listCount"
    );
  },
  mounted() {},

  methods: {
    async load_more(key_words) {
      this.$store.state.main.current_page =
        this.$store.state.main.current_page + 1;
      console.log(this.$store.state.main.offers_content);

      let params = {
        id: _.get(this.$store.state.main.selected_menu, "id"),
        componentUnicId: this.uniq_id,
        searchText: key_words,
        searchTerms: this.$store.state.main.offers_filter_values,
        searchDate: [this.format_calendar.start, this.format_calendar.end],
        pageNumber: this.$store.state.main.current_page,
        perPage: parseInt(this.page_count)
      };

      let res = await fn.postData("main/getDataList", params);
      this.$store.state.main.offers_content = this.$store.state.main.offers_content.concat(
        res.data.list
      );
      this.$store.state.main.trigger_update = !this.$store.state.main
        .trigger_update;
      console.log(this.$store.state.main.offers_content);
      console.log(_.get(this.contentData, "data.listCount"));
      this.$store.state.main.offers_listCount = res.data.listCount;

      if (
        this.$store.state.main.offers_content.length ==
        _.get(res, "data.listCount")
      ) {
        // this.show_load = false;
      } else {
        // this.show_load = true;
      }
    }
  },
  watch: {}
};
</script>
